import { useState } from 'react';

import Button from 'components/Button';

import privacyPolicyData from '../../privacy-policy-content.json';

import './index.css';

const PrivacyPolicy = () => {
  const [language, setLanguage] = useState('English');
  const currentLanguageData =
    privacyPolicyData.languages[
      language as keyof typeof privacyPolicyData.languages
    ];

  return (
    <div className="px-[100px] py-[32px] md:px-[16px] md:pb-4">
      <div className="flex gap-4 absolute top-[100px] left-[100px]">
        {privacyPolicyData.languageOptions.map((lang: string) => (
          <Button
            key={lang}
            className={`h-12 ${
              language === lang
                ? 'bg-primary text-white'
                : 'bg-white text-primary border border-primary'
            }`}
            onClick={() => setLanguage(lang)}
          >
            {lang}
          </Button>
        ))}
      </div>

      <h1 className="text-3xl font-bold mb-8 text-center">
        {currentLanguageData.title}
      </h1>

      <p className="text-base mb-2">{currentLanguageData.introduction.text}</p>

      <ul className="text-base mb-2 privacyList">
        {currentLanguageData.introduction.list.map(
          (item: string, index: number) => (
            <li key={index}>{item}</li>
          ),
        )}
      </ul>

      <p className="text-base mb-4">
        <strong>
          {language === 'French'
            ? 'Questions ou préoccupations ?'
            : 'Questions or concerns?'}
        </strong>{' '}
        {currentLanguageData.introduction.questionsContact}
      </p>

      <h2 className="text-black text-xl font-bold mb-4">
        {currentLanguageData.summaryOfKeyPoints.title}
      </h2>

      {currentLanguageData.summaryOfKeyPoints.points.map(
        (point: any, index: number) => (
          <p key={index} className="text-base mb-4">
            <strong>{point.question}</strong> {point.answer}
          </p>
        ),
      )}

      {currentLanguageData.sections.map((section: any) => (
        <div key={section.number}>
          <h2 className="text-black text-xl font-bold mb-4">
            {section.number}. {section.title}
          </h2>

          <p className="text-base mb-4">{section.content}</p>
        </div>
      ))}
    </div>
  );
};

export default PrivacyPolicy;
